import { getTreePathOfNode } from 'anodum';
import { connectedStore } from '../../store';
import textFormatting from '../../text-formatting';
import view from '../../view';

const getFocusedElementInfo = () => {
  const store = connectedStore.get();
  const state = store.getState();
  const elementId = view.selectors.getFocusedElement(state);
  const rootElement = view.accessors.getLiveElement(elementId);

  if (!rootElement) return null;

  const selection = textFormatting.accessors.getAdvancedSelection();

  const { anchorNode, anchorOffset, focusNode, focusOffset } = selection;

  if (!anchorNode || !focusNode) return null;

  const isBackwards = selection.isBackwards();

  return {
    id: elementId,
    innerHTML: rootElement.innerHTML,
    clonedRootElement: rootElement.cloneNode(true),
    selectionData: {
      isBackwards,
      anchor: {
        path: getTreePathOfNode(anchorNode, rootElement),
        offset: anchorOffset,
      },
      focus: {
        path: getTreePathOfNode(focusNode, rootElement),
        offset: focusOffset,
      },
    },
  };
};

export default getFocusedElementInfo;
